module.exports = __webpack_public_path__ + "img/HNZ_1.609b1e89.png";